<template>
	<div :v-if="age.length" class="bar age" :style="style">
		<span>{{ parseAge(year) }}</span>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	props: ['year'],
	computed : {
		...mapState({
			age: state => state.age.list
		}),
		style() {
			let style = {}
			if(this.age[this.year - 1]) {
				style['background-color'] = this.age[this.year - 1].colour
			}

			return style
		}
	},
	methods: {
		parseAge(year) {
			if(year === 1) {
				return 'Y'
			} else if(year === 7) {
				return '7+'
			} else {
				return year
			}
		}
	}
}
</script>

<style lang="scss">
	.bar.age {
		display: inline-block;
		line-height: 32px;
		text-align: center;
		margin-left: 6px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Common/Age.vue